import { useQueryClient } from '@tanstack/react-query';
import { Form } from 'components/organisms';
import { useScroll } from 'components/templates/application/ApplicationTemplate';
import { FormikHelpers } from 'formik';
import { useParamId } from 'hooks/useParamId';
import { useReadMessages } from 'hooks/useReadMessages';
import { useNavigate } from 'react-router-dom';
import { useGetMessages, useGetThread, usePostMessage } from 'services/chat';
import { ICreateThread } from 'services/chat/types';
import { useGetLabel } from 'services/labels';
import { onErrorShowAllErrorsToast } from 'utils/service/errorHandler';

const SettingsSupportChat = () => {
  const threadId = useParamId();

  const queryClient = useQueryClient();

  const thread = useGetThread(threadId);
  const label = useGetLabel();
  const messages = useGetMessages({ messageThreadId: threadId });

  const createMessage = usePostMessage();

  const navigate = useNavigate();

  const scroll = useScroll({ fetchNextPage: messages.fetchNextPage });

  const onCreateMessage = async (
    values: ICreateThread,
    formikHelpers: FormikHelpers<ICreateThread>,
  ) => {
    const { subject, ...message } = values;
    await createMessage.mutateAsync(
      { threadId, ...message },
      {
        onSuccess: async (thread) => {
          await messages.refetch();
          formikHelpers.resetForm();
        },
        onError: (error) => onErrorShowAllErrorsToast(error),
      },
    );
  };

  useReadMessages(messages.data?.pages.flat(), label.data?.id, async () => {
    await queryClient.refetchQueries({
      queryKey: ['chats-list'],
    });

    await queryClient.refetchQueries({
      queryKey: ['chat-unread-count'],
    });
  });

  return (
    <Form.Support
      initialValues={{
        subject: thread.data?.subject ?? '',
        message: '<p></p>',
        attachments: [],
      }}
      messages={messages.data?.pages.flat().reverse()}
      onSubmit={onCreateMessage}
      isLoading={messages.isLoading}
      isFetchingNextPage={messages.isFetchingNextPage}
      isPending={createMessage.isPending}
      status={thread.data?.messageThreadStatus.id}
    />
  );
};

export default SettingsSupportChat;
